// extracted by mini-css-extract-plugin
module.exports = {"icon":"ButtonArrow_icon__3k5Cz","iconLeft":"ButtonArrow_iconLeft__2El1O","iconRight":"ButtonArrow_iconRight__1rX1i","rotate":"ButtonArrow_rotate__2Jn0H"};